var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['quad-pack', {'static': !_vm.animated}]},[_c('div',{ref:"root",staticClass:"root"})])}
var staticRenderFns = []

export { render, staticRenderFns }